import { setRecordingSink } from './recordingSink';
import { scenarioRecorder } from './scenarioRecorder';
import { Html2CanvasCapturer } from './html2canvasCapturer';
import { isRecorderUiEnabled } from './recorderBuildPolicy';

// Production must not attach RPC recording or screenshot collection merely
// because a transport or UI module imports the recorder composition root.
if (isRecorderUiEnabled()) {
  setRecordingSink(scenarioRecorder);
  scenarioRecorder.setScreenshotCapturer(new Html2CanvasCapturer());
}

export { scenarioRecorder };
